import React from 'react';

export default function AdComponent(props) {
    let currentAd
    if (props.ads.length > 0) {
        props.ads.forEach(ad => {
            const startDate = new Date(ad.adFields.startDate)
            const endDate = new Date(ad.adFields.endDate)
            const now = new Date()
            if (now > startDate && now < endDate) {
                currentAd = ad
            }
        })
    }

    if (!currentAd) {
        return null
    }

    return (
        <div className={`ad-block ad-block--${props.position}`}>
            <a href={currentAd.adFields.externalLink} target="_blank" rel="noopener noreferrer">
                <img src={currentAd.featuredImage.node.mediaItemUrl} alt={currentAd.adFields.altText} />
            </a>
        </div>
    )
}
